import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { withRouter } from "react-router-dom";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";

import WidgetTitleBar from "../../components/widget/WidgetTitleBar";
import PerformList from "../../components/widget/PerformList";
import Testimonials from "../../components/widget/Testimonials";
import WidgetSmallTextLink from "../../components/widget/WidgetSmallTextLink";
import WidgetContainer from "../../components/widget/WidgetContainer";
import YoutubeWidget from "../../components/widget/YoutubeWidget";
import VimeoWidget from "../../components/widget/VimeoWidget";
import SoundCloudWidget from "../../components/widget/SoundCloudWidget";
import SpotifyWidget from "../../components/widget/SpotifyWidget";
import SocialButton from "../../components/widget/SocialButton";
import SongList from "../../components/songListTable/SongListProfile";
import LoadingSpinner from "../../components/loadingSpinner/LoadingSpinner";
import SectionHeader from "../../components/common/SectionHeader";
import classNames from "classnames";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import PersonIcon from "@material-ui/icons/Person";
import QueueMusicIcon from "@material-ui/icons/QueueMusic";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

import Tab from "@material-ui/core/Tab";
import hero2 from "../../components/hero2.jpg";

import "./Profile.css";

import { Typography, Hidden, Paper, Grid, Tabs, Avatar, Button } from "@material-ui/core";
import AddMusicianToGigModal from "../../components/searchPage/modal/AddMusicianToGigModal";
import AddMusicianToActRosterModal from "../../components/searchPage/modal/AddMusicianToActRosterModal";
import { ProfileType } from "../../types/enum";
import image from "../../helper/image";
import MessageModal from "../../components/profile/messageModal/MessageModal";
import qs from "qs";
import agent from "../../agent";
import profileStore from "../../stores/profileStore";
import hg_pro_logo from "../../img/hg_pro_logo.png"

// Video provider detection regexes - permissive patterns for display/rendering
const youtubeReg = /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)/i;
const soundcloudReg = /^https?:\/\/(www\.)?(soundcloud\.com|w\.soundcloud\.com)/i;
const spotifyReg = /^https?:\/\/(open\.spotify\.com)/i;
const vimeoReg = /^https?:\/\/(www\.)?(vimeo\.com|player\.vimeo\.com)/i;
const facebookVideoReg = /^https?:\/\/(www\.)?(facebook\.com|fb\.watch)/i;
const tiktokReg = /^https?:\/\/(www\.)?(tiktok\.com|vm\.tiktok\.com)/i;

// Demo mode disabled - using actual profile data
const DEMO_MODE = false;

@inject("profileStore", "templateStore", "bookingRequestStore", "reportStore")
@withRouter
@observer
class MusicianProfile extends Component {
    timeoutValue = null;

    constructor(props) {
        super(props);
        this.props.reportStore.clearDateRangeFilter();
        this.state = {
            value: 0,
            backgroundImageIndex: 0,
            showMusicianGigInvitationModal: false,
            showMusicianActInvitationModal: false,
            showMessageModal: false,
            instrumentData: [],
            isCurrentUser: false,
            lightboxOpen: false,
            lightboxIndex: 0
        };
    }

    componentDidMount = () => {
        const profile = this.props.profile || this.props.profileStore.profile;
        const currentProfile = this.props.profileStore.getCurrentProfile();

        if(currentProfile && currentProfile.userId === profile.userId) {
            this.setState({isCurrentUser: true})
        }

        if (profile && profile.backgroundImages) {
            for (let i = 0; i < profile.backgroundImages.length; i++) {
                // caches images, avoiding white flash between background replacements
                new Image().src = profile.backgroundImages[i].url1920;
            }
            this.changeBackground(0);
        }

        // Skip API calls for demo profile
        if (profile && profile.id === "demo-musician") {
            return;
        }

        this.props.templateStore.showLoadingScreen();
        
        // this.props.bookingRequestStore.loadUpcomingGigsWithoutAdhoc(profile.id).then(() => {
        this.props.bookingRequestStore.loadEntertainmentUpcomingGigsWithoutAdhocGigGuideEmbed(profile.id).then(() => {
            this.props.templateStore.hideLoadingScreen();
        }).catch(() => {
            this.props.templateStore.hideLoadingScreen();
        });

        const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        if (parsed) {
            if (parsed.contact) {
                this.showMessageModal();
            }
        }

        if (profile && profile.profileInstruments) {

            profileStore.getInstrumentNameByInstrumentProfile(profile.profileInstruments).then(result=>{

                this.setState({
                    ...this.state,
                    instrumentData: result
                });

            })

        }
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    changeBackground = index => {
        const profile = this.props.profile || this.props.profileStore.profile;
        this.setState({ backgroundImageIndex: index });

        this.timeoutValue = setTimeout(() => {
            let newIndex = this.state.backgroundImageIndex + 1 < profile.backgroundImages.length ? this.state.backgroundImageIndex + 1 : 0;
            this.changeBackground(newIndex);
        }, 5000);
    };

    manualChangeBackground = index => () => {
        clearTimeout(this.timeoutValue);
        this.changeBackground(index);
    };

    processUpcomingGigs = upcomingGigs => {
        let result = [];
        upcomingGigs = upcomingGigs.sort((a,b) => (a.dateStart > b.dateStart) ? 1 : ((b.dateStart > a.dateStart) ? -1 : 0))
        for (let i = 0; i < upcomingGigs.length; i++) {
            let dateStart = moment(upcomingGigs[i].dateStart);
            let data = {
                month: dateStart.format("MMMM"),
                date: dateStart.format("D"),
                day: dateStart.format("dddd"),
                venue: upcomingGigs[i].venueName ? upcomingGigs[i].venueName : upcomingGigs[i]?.venue?.profileName ? upcomingGigs[i]?.venue?.profileName : "",
                address: upcomingGigs[i].venueAddress,
                time:
                    moment(upcomingGigs[i].timeStart, "HH:mm:ss").format(this.props.templateStore.getFormat12Hour(upcomingGigs[i].timeStart)) +
                    " - " +
                    moment(upcomingGigs[i].timeEnd, "HH:mm:ss").format(this.props.templateStore.getFormat12Hour(upcomingGigs[i].timeEnd)),
                actName: upcomingGigs[i].actName,
                actUrl: "/profile/" + upcomingGigs[i].actId,
                venueUrl: "/profile/" + upcomingGigs[i].venueId
            };
            result.push(data);
        }
        return result;
    };

    showMusicianGigInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianGigInvitationModal: true
        });
    };

    hideMusicianGigInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianGigInvitationModal: false
        });
    };

    showMusicianActInvitationModal = () => {
        this.setState({
            ...this.state,
            showMusicianActInvitationModal: true
        });
    };

    hideMusicianActInvitationModal = () => {
        this.setState({
            showMusicianActInvitationModal: false
        });
    };

    showMessageModal = () => {
        this.setState({
            showMessageModal: true
        });
    };

    openLightbox = (index) => {
        this.setState({ lightboxOpen: true, lightboxIndex: index });
    };

    closeLightbox = () => {
        this.setState({ lightboxOpen: false });
    };

    navigateLightbox = (direction) => {
        const profile = this.props.profile || this.props.profileStore.profile;
        const galleryImages = (profile && profile.galleryImages && profile.galleryImages.length > 0)
            ? profile.galleryImages
            : [];
        
        let newIndex = this.state.lightboxIndex + direction;
        if (newIndex < 0) newIndex = galleryImages.length - 1;
        if (newIndex >= galleryImages.length) newIndex = 0;
        this.setState({ lightboxIndex: newIndex });
    };

    handleLightboxKeyDown = (e) => {
        if (e.key === 'Escape') this.closeLightbox();
        if (e.key === 'ArrowLeft') this.navigateLightbox(-1);
        if (e.key === 'ArrowRight') this.navigateLightbox(1);
    };

    hideMessageModal = () => {
        this.setState({
            showMessageModal: false
        });
    };

    handleButtonMessage = (e) => {
      
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const profile = this.props.profile || this.props.profileStore.profile;
        if(this.state.isCurrentUser) {
            e.preventDefault();
            this.props.history.push('/messages/new');
        } else {
            if (currentProfile) {
                e.preventDefault();
                this.props.history.push({
                    pathname: '/messages/new',
                    state: { profile }
                })
            } else {
                this.setState({showMessageModal: true})
            }
        }
    }

    render() {
        const profile = this.props.profile || this.props.profileStore.profile;
        let { upcomings, embedUpcomingGigs } = this.props.bookingRequestStore;
        const { currentProfile } = this.props.profileStore;
        const { showMusicianGigInvitationModal, showMusicianActInvitationModal } = this.state;
        let performData = this.processUpcomingGigs(embedUpcomingGigs);
        let widgetSmallTextLinksPlayedAt = {
            title: "Played At",
            datas: []
        };

        if (profile && profile.playedAts) {
            widgetSmallTextLinksPlayedAt.datas = profile.playedAts.map(playedAt => ({
                text: playedAt.name,
                secondaryText: playedAt.suburb + (playedAt.state ? ", " + playedAt.state : "") + (playedAt.country ? ", " + playedAt.country : ""),
                link: "#"
            }));
        }

        let widgetSmallTextLinksPlayedWith = {
            title: "Played With",
            datas: []
        };

        if (profile && profile.playedWiths && profile.showPlayedWith) {
            widgetSmallTextLinksPlayedWith.datas = profile.playedWiths.map(playedWith => ({
                text: playedWith.name,
                secondaryText: playedWith.notes,
                link: "#"
            }));
        }
        
        let widgetSmallTextLinksSkillSet = {
            title: "Skill Set",
            datas: this.state.instrumentData
        };

        let widgetSmallTextLinksCount =
            (widgetSmallTextLinksPlayedAt.datas.length > 0 ? 1 : 0) +
            (widgetSmallTextLinksPlayedWith.datas.length > 0 ? 1 : 0) +
            (widgetSmallTextLinksSkillSet.datas.length > 0 ? 1 : 0);

        // Parse videos from videoUrl field ( ||| delimited)
        const parseVideoUrlString = (urlString) => {
            if (!urlString || typeof urlString !== 'string') return [];
            return urlString
                .split(" ||| ")
                .map(url => url.trim())
                .filter(url => url.length > 0)
                .map((url, index) => ({ id: `video-${index}`, url }));
        };
        
        const videoUrls = profile && profile.videoUrl 
            ? parseVideoUrlString(profile.videoUrl)
            : [];
        const hasVideos = videoUrls.length > 0;
        
        // Get gallery images from profile data
        const galleryImages = (profile && profile.galleryImages && profile.galleryImages.length > 0)
            ? profile.galleryImages
            : [];

        // Get acts owned by this musician (myActs is the standard property name)
        const ownedActs = (profile && profile.myActs && profile.myActs.length > 0)
            ? profile.myActs
            : [];
        
        // Get acts this musician performs in (as a member)
        const memberActs = (profile && profile.memberActs && profile.memberActs.length > 0)
            ? profile.memberActs
            : [];

        // Render video based on provider
        const renderVideo = (video, index) => {
            const url = video.url || video;
            if (url.match(youtubeReg)) {
                return <YoutubeWidget key={index} url={url} />;
            } else if (url.match(vimeoReg)) {
                return <VimeoWidget key={index} url={url} height="300px" />;
            } else if (url.match(facebookVideoReg)) {
                return (
                    <div key={index} className="facebook-video-embed" style={{ background: '#333', padding: '20px', borderRadius: '8px', textAlign: 'center', color: '#fff' }}>
                        <Typography variant="body2">Facebook Video</Typography>
                        <Typography variant="caption" style={{ wordBreak: 'break-all' }}>{url}</Typography>
                    </div>
                );
            } else if (url.match(tiktokReg)) {
                return (
                    <div key={index} className="tiktok-video-embed" style={{ background: '#333', padding: '20px', borderRadius: '8px', textAlign: 'center', color: '#fff' }}>
                        <Typography variant="body2">TikTok Video</Typography>
                        <Typography variant="caption" style={{ wordBreak: 'break-all' }}>{url}</Typography>
                    </div>
                );
            }
            return null;
        };

        let profileContent = (
            <div className="profile-content">
                <Grid container spacing={16}>
                    {/* VIDEOS SECTION - Multiple Videos Support */}
                    {hasVideos && (
                        <Grid item xs={12}>
                            <div className="standalone-widget-title">
                                <WidgetTitleBar title={profile ? profile.fullName + "'s Videos" : "Videos"} showBadge={false} />
                            </div>
                            <Grid container spacing={16}>
                                {videoUrls.length > 0 ? (
                                    videoUrls.map((video, index) => (
                                        <Grid item xs={12} sm={videoUrls.length === 1 ? 12 : 6} key={video.id || index}>
                                            {renderVideo(video, index)}
                                        </Grid>
                                    ))
                                ) : null}
                            </Grid>
                        </Grid>
                    )}

                    {/* SOUNDS SECTION */}
                    {profile && profile.musicUrl ? (
                        <Grid item xs={12}>
                            <div className="standalone-widget-title">
                                <WidgetTitleBar title={profile && profile.fullName + "'s Sound"} showBadge={false} />
                            </div>
                            {profile && profile.musicUrl && profile.musicUrl.match(soundcloudReg) && <SoundCloudWidget url={profile && profile.musicUrl} />}
                            {profile &&
                                profile.musicUrl &&
                                profile.musicUrl.match(spotifyReg) && <SpotifyWidget url={profile && profile.musicUrl} />}
                        </Grid>
                    ) : null}

                    {widgetSmallTextLinksPlayedAt.datas.length ? (
                        <Grid item xs={12} lg={12 / widgetSmallTextLinksCount}>
                            <WidgetSmallTextLink data={widgetSmallTextLinksPlayedAt} />
                        </Grid>
                    ) : null}

                    {widgetSmallTextLinksPlayedWith.datas.length ? (
                        <Grid item xs={12} lg={12 / widgetSmallTextLinksCount}>
                            <WidgetSmallTextLink data={widgetSmallTextLinksPlayedWith} />
                        </Grid>
                    ) : null}

                    {/* PHOTO GALLERY STRIP - Single line above Skill Set */}
                    {galleryImages.length > 0 && (
                        <Grid item xs={12}>
                            <div className="standalone-widget-title">
                                <WidgetTitleBar title={profile ? profile.fullName + "'s Photo Gallery" : "Photo Gallery"} showBadge={false} />
                            </div>
                            <div className="gallery-strip-container">
                                <div className="gallery-strip">
                                    <Grid container spacing={16}>
                                    {galleryImages.map((img, index) => (
                                        <Grid item md={6} xs={12}>
                                        <div 
                                            key={img.id || index}
                                            className="gallery-strip-item"
                                            onClick={() => this.openLightbox(index)}
                                        >
                                            <img 
                                                src={img.url || img.fileUrl} 
                                                alt={img.title || img.fileName || `Gallery ${index + 1}`}
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                        </div>
                                        </Grid>
                                    ))}
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                    )}

                    {widgetSmallTextLinksSkillSet.datas.length ? (
                        <Grid item xs={12} lg={12 / widgetSmallTextLinksCount}>
                            <WidgetSmallTextLink data={widgetSmallTextLinksSkillSet} />
                        </Grid>
                    ) : null}

                    {profile && profile.songLists && profile.songLists.length > 0 ? (
                        <Grid item xs={12} lg={12} className="songlist">
                            <WidgetContainer title={profile && profile.fullName + "'s Song List"} showBadge={false}>
                                <SongList songs={profile && profile.songLists} musician={profile && profile.fullName} />
                            </WidgetContainer>
                        </Grid>
                    ) : null}

                    {profile && profile.testimonials && profile.testimonials.length > 0 ? (
                        <Grid item xs={12}>
                            <div className="widget-title-bar-yellow standalone-widget-title">
                                <WidgetTitleBar title="Testimonials" showBadge={false} />
                            </div>

                            <Testimonials testimonials={profile && profile.testimonials} />
                        </Grid>
                    ) : null}


                    {/* ACTS SECTION - from profile.acts API field */}
                    {profile && profile.acts && profile.acts.length > 0 && (
                        <Grid item xs={12}>
                            <div className="standalone-widget-title">
                                <WidgetTitleBar title="Acts" showBadge={false} />
                            </div>
                            <Grid container spacing={16} className="profile-acts">
                                {profile.acts.map((item, index) => {
                                    const actData = item.act || item;
                                    const actProfile = actData.profile || actData;
                                    const actName = actData.actName || actProfile.actName || actProfile.fullName;
                                    const actId = item.actProfileId || actData.actProfileId || actProfile.id;
                                    if (!actId) return null;
                                    return (
                                        <Grid item xs={6} sm={3} key={actId || index}>
                                            <div 
                                                className="act-card"
                                                onClick={() => this.props.history.push(`/profile/${actId}`)}
                                                style={{
                                                    borderRadius: '8px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#fff',
                                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
                                                }}
                                            >
                                                <div style={{ 
                                                    width: '100%', 
                                                    aspectRatio: '4/3', 
                                                    overflow: 'hidden',
                                                    backgroundColor: '#f0f0f0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    {image.getProfileImage(actProfile) ? (
                                                        <img 
                                                            src={image.getProfileImage(actProfile)} 
                                                            alt={actName || 'Act'} 
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                        />
                                                    ) : (
                                                        <Typography style={{ color: '#999', fontSize: '14px' }}>No Image</Typography>
                                                    )}
                                                </div>
                                                <div style={{ padding: '12px' }}>
                                                    <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                        {actName || 'Unnamed Act'}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </div>
        );

        return (
            <div>
                <LoadingSpinner showed={this.props.templateStore.loadingScreenState} />
                <Header forceToggler />
                <Sidebar forceMobile />
                <div className="profile-header">
                    <div className="profile-header-information-container">
                        {profile &&
                            profile.showAvatar && (
                                <div className="profile-header-inner">
                                    <Avatar classes={{ root: "profile-avatar" }} src={image.getProfileImage(profile)} alt={profile.fullName} />
                                </div>
                            )}
                        <div className="profile-header-text profile-header-inner">
                            <Typography type="headline" component="h3">
                                {profile && profile.fullName}  <img style={{display:this.props.isFreePlan ? "none":"inline"}} src={ hg_pro_logo } width="50px"/>
                            </Typography>
                            <Typography component="p">Artist/Entertainer</Typography>
                            
                            <br />
                            {profile && (profile.city || profile.state) ? (
                                <Typography component="p">
                                    <LocationOnIcon classes={{ root: "profile-header-icon" }} />
                                    {profile.city && profile.state
                                        ? profile.city + ", " + profile.state
                                        : profile.city
                                            ? profile.city
                                            : profile.state
                                                ? profile.state
                                                : null}
                                </Typography>
                            ) : null}
                        </div>
                        <div className="profile-header-inner">
                            <SocialButton variant="webSite" urlData={profile && profile.webSite} />
                            <SocialButton variant="facebook" urlData={profile && profile.facebook} />
                            <SocialButton variant="twitter" urlData={profile && profile.twitter} />
                            <SocialButton variant="bandcamp" urlData={profile && profile.bandcamp} />
                            <SocialButton variant="soundcloud" urlData={profile && profile.soundcloud} />
                            <SocialButton variant="mixcloud" urlData={profile && profile.mixcloud} />
                            <SocialButton variant="youtube" urlData={profile && profile.youtube} />
                            <SocialButton variant="instagram" urlData={profile && profile.instagram} />
                            <SocialButton variant="googlePlus" urlData={profile && profile.googlePlus} />
                            <SocialButton variant="linkedIn" urlData={profile && profile.linkedIn} />
                            <SocialButton variant="iTunes" urlData={profile && profile.iTunes} />
                            <SocialButton variant="spotify" urlData={profile && profile.spotify} />
                        </div>

                        <div className="profile-header-inner">
                            {currentProfile &&
                                currentProfile.type === ProfileType.Musician.ordinal &&
                                currentProfile.id !== profile.id && (
                                    <Fragment>
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="actionButton"
                                            onClick={this.showMusicianActInvitationModal}
                                        >
                                            Invite to Act
                                        </Button>
                                        <Button
                                            variant="raised"
                                            color="primary"
                                            className="actionButton"
                                            onClick={this.showMusicianGigInvitationModal}
                                        >
                                            Invite to Gig
                                        </Button>
                                        <AddMusicianToGigModal
                                            open={showMusicianGigInvitationModal}
                                            onClose={this.hideMusicianGigInvitationModal}
                                            profileName={profile.fullName}
                                            profileImage={image.getProfileImage(profile)}
                                            profile={profile}
                                        />
                                        <AddMusicianToActRosterModal
                                            open={showMusicianActInvitationModal}
                                            onClose={this.hideMusicianActInvitationModal}
                                            profileName={profile.fullName}
                                            profileImage={image.getProfileImage(profile)}
                                            profile={profile}
                                        />
                                    </Fragment>
                                )}
                            {currentProfile && !this.state.isCurrentUser ?
                                <Button variant="raised" color="primary" className="actionButton" onClick={(e) => {
                                        this.handleButtonMessage(e)
                                        }} >
                                    Message
                                </Button>
                                : ""
                            }
                           
                            <MessageModal profile={profile} open={this.state.showMessageModal} closeHandler={this.hideMessageModal} />
                        </div>

                        {profile &&
                            profile.backgroundImages &&
                            profile.backgroundImages.length > 1 && (
                                <div className="profile-header-inner-slider">
                                    {profile.backgroundImages.map((backgroundImage, i) => {
                                        return (
                                            <div
                                                key={i}
                                                index={i}
                                                className={classNames(
                                                    "background-image-control",
                                                    this.state.backgroundImageIndex === i ? "active" : "inactive"
                                                )}
                                                onClick={this.manualChangeBackground(i)}
                                            />
                                        );
                                    })}
                                </div>
                            )}
                    </div>
                    {profile &&
                        profile.backgroundImages && (
                            <React.Fragment>
                                {profile.backgroundImages.map((backgroundImage, i) => {
                                    return (
                                        <div
                                            className={classNames(
                                                "profile-header-background-image",
                                                this.state.backgroundImageIndex === i ? "active" : "inactive"
                                            )}
                                            style={{ backgroundImage: "url('" + backgroundImage.url1920 + "')" }}
                                            key={i}
                                        />
                                    );
                                })}
                            </React.Fragment>
                        )}

                    {(!profile || !profile.backgroundImages || profile.backgroundImages.length === 0) && (
                        <React.Fragment>
                            <div
                                className={classNames("profile-header-background-image", "active")}
                                style={{ backgroundImage: `url(${hero2})` }}
                                key={0}
                            />
                        </React.Fragment>
                    )}
                </div>

                <div className="profile-body">
                    <Hidden smDown>
                        <div className="profile-sidebar">
                            <Grid container spacing={16}>
                                {performData &&
                                    performData.length > 0 && (
                                        <React.Fragment>
                                            <Grid item xs={12}>
                                                <div className="border-bottom-grid">
                                                    <Grid container alignItems="center">
                                                        <Grid item xs={12}>
                                                            <Typography type="headline" component="h4" className="profile-sidebar-title">
                                                                {profile && profile.fullName}'s Live Gigs
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </Grid>

                                            <Grid item xs={12} style={{ height:"100%", marginBottom: "50px" }}>
                                                <PerformList performData={performData} />
                                            </Grid>
                                        </React.Fragment>
                                    )}
                                <Grid item xs={12}>
                                    <div className="border-bottom-grid">
                                        <Typography type="headline" component="h4" className="profile-sidebar-title">
                                            {profile && profile.fullName}'s Bio
                                        </Typography>
                                    </div>
                                </Grid>

                                <Grid item xs={12} className="profile-bio-content">
                                    <Typography component="div">
                                        <div className="bio-section" dangerouslySetInnerHTML={{ __html: profile && profile.bio }} />{" "}
                                    </Typography>
                                </Grid>
                                
                                {
                                    profile.showContactPhone || profile.showEmail
                                    ?   <Grid item xs={12}>
                                            <div className="border-bottom-grid">
                                                <Typography type="headline" component="h4" className="profile-sidebar-title">
                                                    Contact
                                                </Typography>
                                            </div>
                                        </Grid>
                                    :   null
                                }
                                {
                                    profile.showContactPhone || profile.showEmail
                                    ?   <Grid item xs={12} className="profile-sidebar-contact">
                                            <Grid container spacing={8}>
                                                {
                                                    profile.showContactPhone
                                                    ?   <Grid item xs={12}>
                                                            <Typography component="div">
                                                                <PhoneIcon />
                                                                {profile.showContactPhone && profile.contactPhone !== '' ? profile.contactPhone : '-'}
                                                            </Typography>
                                                        </Grid>
                                                    :   null
                                                }
                                                {
                                                    profile.showEmail
                                                    ?   <Grid item xs={12}>
                                                            <Typography component="div">
                                                                <EmailIcon />
                                                                {profile.showEmail && profile.email !== '' ? profile.email : '-'}
                                                            </Typography>
                                                        </Grid>
                                                    :   null
                                                }
                                            </Grid>
                                        </Grid>
                                    :   null
                                }
                                
                                {
                                    profile.insuranceExpiryDate
                                    ?   <Grid item xs={12}>
                                            <div className="border-bottom-grid">
                                                <Typography type="headline" component="h4" className="profile-sidebar-title">
                                                    Public Liability Insurance
                                                </Typography>
                                            </div>
                                        </Grid>
                                    :   null
                                }
                                {
                                    profile.insuranceExpiryDate
                                    ?   <Grid item xs={12} className="profile-sidebar-insurance">
                                            <Grid container spacing={8}>
                                                <Grid item xs={12}>
                                                    <Typography component="div" className={moment(profile.insuranceExpiryDate).isBefore(moment()) ? "insurance-expired" : moment(profile.insuranceExpiryDate).isBefore(moment().add(30, 'days')) ? "insurance-expiring-soon" : "insurance-valid"}>
                                                        <VerifiedUserIcon />
                                                        <span className="insurance-status">
                                                            {moment(profile.insuranceExpiryDate).isBefore(moment()) 
                                                                ? "Expired" 
                                                                : "Insured"}
                                                        </span>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography component="div" className="insurance-expiry">
                                                        {moment(profile.insuranceExpiryDate).isBefore(moment()) 
                                                            ? `Expired: ${moment(profile.insuranceExpiryDate).format("D MMM YYYY")}`
                                                            : `Expires: ${moment(profile.insuranceExpiryDate).format("D MMM YYYY")}`}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    :   null
                                }
                            </Grid>
                        </div>

                        {profileContent}
                    </Hidden>

                    <Hidden mdUp>
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Paper style={{ width: "100%", backgroundColor: "#ff0c9c" }}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        indicatorColor="secondary"
                                        textColor="secondary"
                                        centered
                                        fullWidth
                                    >
                                        <Tab icon={<PersonIcon />} label="Profile" />
                                        <Tab icon={<QueueMusicIcon />} label="Live Gigs" />
                                        <Tab icon={<ImportContactsIcon />} label="Bio" />
                                    </Tabs>
                                </Paper>
                            </Grid>

                            {this.state.value === 0 && (
                                <Grid item xs={12}>
                                    {profileContent}
                                </Grid>
                            )}
                            {this.state.value === 1 && (
                                <Grid item xs={12}>
                                    <div className="profile-content">
                                        <WidgetContainer title={profile && profile.fullName + "'s Live Gigs"} showBadge={false}>
                                            <PerformList performData={performData} />
                                        </WidgetContainer>
                                    </div>
                                </Grid>
                            )}
                            {this.state.value === 2 && (
                                <Grid item xs={12}>
                                    <div className="profile-content">
                                        <WidgetContainer title={profile && profile.fullName + "'s Bio"} showBadge={false} style={{backgroundColor:"#333"}}>
                                            <Typography component="p">
                                                <div className="bio-section"  dangerouslySetInnerHTML={{ __html: profile && profile.bio }} />{" "}
                                            </Typography>
                                        </WidgetContainer>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                    </Hidden>
                </div>

                {/* LIGHTBOX MODAL */}
                {this.state.lightboxOpen && galleryImages.length > 0 && (
                    <div 
                        className="lightbox-overlay"
                        onClick={this.closeLightbox}
                        onKeyDown={this.handleLightboxKeyDown}
                        tabIndex={0}
                        ref={(el) => el && el.focus()}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999
                        }}
                    >
                        <button
                            onClick={this.closeLightbox}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '20px',
                                background: 'none',
                                border: 'none',
                                color: 'white',
                                fontSize: '32px',
                                cursor: 'pointer',
                                zIndex: 10000,
                                padding: '10px'
                            }}
                        >
                            &times;
                        </button>
                        
                        {galleryImages.length > 1 && (
                            <button
                                onClick={(e) => { e.stopPropagation(); this.navigateLightbox(-1); }}
                                style={{
                                    position: 'absolute',
                                    left: '20px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '28px',
                                    cursor: 'pointer',
                                    padding: '15px 20px',
                                    borderRadius: '50%',
                                    transition: 'background 0.2s'
                                }}
                            >
                                &#8249;
                            </button>
                        )}

                        <div 
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '85vh',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}
                        >
                            <img 
                                src={galleryImages[this.state.lightboxIndex]?.url || galleryImages[this.state.lightboxIndex]?.fileUrl}
                                alt={galleryImages[this.state.lightboxIndex]?.title || galleryImages[this.state.lightboxIndex]?.fileName || 'Gallery image'}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '80vh',
                                    objectFit: 'contain',
                                    borderRadius: '4px'
                                }}
                            />
                            <div style={{ 
                                color: 'white', 
                                marginTop: '15px',
                                textAlign: 'center'
                            }}>
                                <Typography variant="body1" style={{ color: 'white' }}>
                                    {galleryImages[this.state.lightboxIndex]?.title || galleryImages[this.state.lightboxIndex]?.fileName || ''}
                                </Typography>
                                <Typography variant="caption" style={{ color: 'rgba(255,255,255,0.7)' }}>
                                    {this.state.lightboxIndex + 1} / {galleryImages.length}
                                </Typography>
                            </div>
                        </div>

                        {galleryImages.length > 1 && (
                            <button
                                onClick={(e) => { e.stopPropagation(); this.navigateLightbox(1); }}
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '28px',
                                    cursor: 'pointer',
                                    padding: '15px 20px',
                                    borderRadius: '50%',
                                    transition: 'background 0.2s'
                                }}
                            >
                                &#8250;
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default MusicianProfile;
